import * as React from 'react';

import { useFormContext } from 'common/components/form/FormContext';
import FormSubmitButton from 'components/lib/form/FormSubmitButton';
import TextField from 'components/lib/form/TextField';
import CardFooter from 'components/lib/ui/CardFooter';
import FlexContainer from 'components/lib/ui/FlexContainer';
import InformationList, { InformationItem } from 'components/lib/ui/InformationList';
import Markdown from 'components/lib/ui/Markdown';
import ModalCard from 'components/lib/ui/ModalCard';
import DefaultButton from 'components/lib/ui/button/DefaultButton';
import type { DeleteMemberFormValues } from 'components/settings/members/DeleteMemberModal';

import { MEMBERS } from 'common/constants/copy';

type Props = {
  name: string;
  onCancel: () => void;
  disabled: boolean;
};

export const DeleteMemberModalInnerForm: React.FC<Props> = ({ name, onCancel, disabled }) => {
  const { values } = useFormContext<DeleteMemberFormValues>();

  const submitButtonDisabled =
    disabled || values.memberNameConfirmation.toLowerCase() !== name.toLowerCase();

  return (
    <ModalCard title={MEMBERS.REMOVE_MEMBER.TITLE}>
      <FlexContainer padding="large" column gap="xlarge">
        <Markdown>{MEMBERS.REMOVE_MEMBER.DESCRIPTION(name)}</Markdown>

        <InformationList title={MEMBERS.REMOVE_MEMBER.LIST_TITLE}>
          {MEMBERS.REMOVE_MEMBER.LIST_ITEMS.map((item) => (
            <InformationItem key={typeof item === 'string' ? item : item(name)} iconName="x-circle">
              <Markdown>{typeof item === 'string' ? item : item(name)}</Markdown>
            </InformationItem>
          ))}
        </InformationList>

        <TextField
          name="memberNameConfirmation"
          label={`Type "${name}" to confirm deletion`}
          required
        />
      </FlexContainer>
      <CardFooter>
        <DefaultButton onClick={onCancel} disabled={disabled}>
          Cancel
        </DefaultButton>
        <FormSubmitButton size="small" disabled={submitButtonDisabled}>
          {MEMBERS.REMOVE_MEMBER.SUBMIT_BUTTON}
        </FormSubmitButton>
      </CardFooter>
    </ModalCard>
  );
};
